import { render, staticRenderFns } from "./kllk-menu-phone.vue?vue&type=template&id=29021a54&scoped=true&"
import script from "./kllk-menu-phone.vue?vue&type=script&lang=js&"
export * from "./kllk-menu-phone.vue?vue&type=script&lang=js&"
import style0 from "./kllk-menu-phone.vue?vue&type=style&index=0&id=29021a54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29021a54",
  null
  
)

export default component.exports